module.exports = __webpack_public_path__ + "img/introduce.eb84a7e9.png";